import Reducer from 'modules/Referral/ReferralLinks/reducer'
import Sagas from 'modules/Referral/ReferralLinks/saga'

import ReferralLinks from 'modules/Referral/ReferralLinks/ReferralLinks'

export default ReferralLinks

export { Reducer, Sagas as Sagas }
